"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalTaskApiClient = void 0;
const index_1 = require("../Types/index");
const BaseClient_1 = require("./BaseClient");
const Mappers_1 = require("./Lib/Mappers");
class ExternalTaskApiClient extends BaseClient_1.BaseClient {
    async getAllDeployedTopics(identity) {
        const url = this.buildUrl(index_1.restSettings.paths.getAllDeployedTopics);
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const response = await this
            .httpClient
            .get(url, requestAuthHeaders);
        return response.result;
    }
    async fetchAndLockExternalTasks(workerId, topicNames, maxTasks, longPollingTimeout, lockDuration, payloadFilter, identity) {
        const httpPayload = {
            workerId: workerId,
            topicName: topicNames,
            maxTasks: maxTasks,
            longPollingTimeout: longPollingTimeout,
            lockDuration: lockDuration,
            payloadFilter: payloadFilter === null || payloadFilter === void 0 ? void 0 : payloadFilter.toString(),
        };
        const url = this.buildUrl(index_1.restSettings.paths.fetchAndLockExternalTasks);
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const response = await this
            .httpClient
            .post(url, httpPayload, requestAuthHeaders);
        const mappedResult = response.result.map((result) => (0, Mappers_1.mapExternalTask)(result));
        return mappedResult;
    }
    async extendLock(workerId, externalTaskId, additionalDuration, identity) {
        const httpPayload = {
            workerId: workerId,
            additionalDuration: additionalDuration,
        };
        const endpoint = index_1.restSettings.paths.extendExternalTaskLock
            .replace(index_1.restSettings.params.externalTaskId, externalTaskId);
        const url = this.buildUrl(endpoint);
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        await this
            .httpClient
            .put(url, httpPayload, requestAuthHeaders);
    }
    async handleBpmnError(workerId, externalTaskId, error, identity) {
        const httpPayload = {
            workerId: workerId,
            bpmnError: error,
        };
        const endpoint = index_1.restSettings.paths.finishExternalTaskWithBpmnError
            .replace(index_1.restSettings.params.externalTaskId, externalTaskId);
        const url = this.buildUrl(endpoint);
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        await this
            .httpClient
            .put(url, httpPayload, requestAuthHeaders);
    }
    async handleServiceError(workerId, externalTaskId, error, identity) {
        const httpPayload = {
            workerId: workerId,
            error: error,
        };
        const endpoint = index_1.restSettings.paths.finishExternalTaskWithServiceError
            .replace(index_1.restSettings.params.externalTaskId, externalTaskId);
        const url = this.buildUrl(endpoint);
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        await this
            .httpClient
            .put(url, httpPayload, requestAuthHeaders);
    }
    async finishExternalTask(workerId, externalTaskId, result, identity) {
        const httpPayload = {
            workerId: workerId,
            result: result,
        };
        const endpoint = index_1.restSettings.paths.finishExternalTask
            .replace(index_1.restSettings.params.externalTaskId, externalTaskId);
        const url = this.buildUrl(endpoint);
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        await this
            .httpClient
            .put(url, httpPayload, requestAuthHeaders);
    }
}
exports.ExternalTaskApiClient = ExternalTaskApiClient;
//# sourceMappingURL=ExternalTaskApiHttpClient.js.map